import { IconAnimatedRight } from './Animated/Right';
import { IconRight } from './Right';

export const IconArrow = {
  AnimatedArrowRight: IconAnimatedRight,
  ArrowRight: IconRight,
};
